import { Slider } from '@mui/material';
import { Check } from '@phosphor-icons/react';
import { Button, Tag, VText, cx } from '@vake/ui-kit';
import { FC, SyntheticEvent } from 'react';

export type Props = {
    darkDetectionConfidence: number;
    setDarkDetectionConfidence: (value: number) => void;
    defaultConfidence: number;
    verifiedActive: boolean;
    darkActive: boolean;
    unCorrelatedActive: boolean;
    setVerifiedActive: (value: boolean) => void;
    setDarkActive: (value: boolean) => void;
    setUnCorrelatedActive: (value: boolean) => void;
    numVerified: number;
    numDark: number;
    numUncorrelated: number;
    tags: Tag[];
    setTags: (value: Tag[]) => void;
};
export const Filters: FC<Props> = ({
    darkDetectionConfidence,
    setDarkDetectionConfidence,
    defaultConfidence,
    verifiedActive,
    darkActive,
    unCorrelatedActive,
    setVerifiedActive,
    setDarkActive,
    setUnCorrelatedActive,
    numVerified,
    numDark,
    numUncorrelated,
    tags,
    setTags,
}) => {
    const updateTag = (index: number) => {
        const newTags = [...tags];
        newTags[index].subtle = !tags[index].subtle;
        setTags(newTags);
    };
    const resetTags = () => {
        setTags(
            tags.map((tag) => ({
                ...tag,
                subtle: true,
            }))
        );
    };
    const handleSliderChange = (e: Event | SyntheticEvent, newValue: number | number[]) => {
        if (!Array.isArray(newValue)) {
            setDarkDetectionConfidence(newValue);
        }
    };
    const resetAllFilters = () => {
        setDarkDetectionConfidence(defaultConfidence);
        setVerifiedActive(false);
        setDarkActive(false);
        setUnCorrelatedActive(false);
        resetTags();
    };

    return (
        <div className="p-4">
            <div className="py-2">
                <VText>Dark detection confidence</VText>
                <Slider
                    value={darkDetectionConfidence}
                    min={0}
                    max={100}
                    step={1}
                    valueLabelDisplay="auto"
                    valueLabelFormat={(value) => <div>{`${value}%`}</div>}
                    onChange={handleSliderChange}
                />
            </div>
            <div className="py-2">
                <VText>Detection Type</VText>
                <button
                    className={cx('border rounded p-1 border-green-400 m-1', verifiedActive ? 'bg-green-400' : '')}
                    onClick={() => setVerifiedActive(!verifiedActive)}
                >
                    <VText>Verified ({numVerified})</VText>
                </button>
                <button
                    className={cx('border rounded p-1 border-red-400 m-1', darkActive ? 'bg-red-400' : '')}
                    onClick={() => setDarkActive(!darkActive)}
                >
                    <VText>Dark Vessel ({numDark})</VText>
                </button>
                <button
                    className={cx('border rounded p-1 border-blue-400 m-1', unCorrelatedActive ? 'bg-blue-400' : '')}
                    onClick={() => setUnCorrelatedActive(!unCorrelatedActive)}
                >
                    <VText>Uncorrelated AIS ({numUncorrelated})</VText>
                </button>
            </div>
            <div className="py-2">
                <VText>Tags</VText>
                <div className="flex flex-wrap px-3 py-2 gap-2 mb-2">
                    {tags &&
                        tags.map((tag, index) => (
                            <button
                                key={index}
                                onClick={() => {
                                    updateTag(index);
                                }}
                            >
                                <Tag {...tag} />
                            </button>
                        ))}
                </div>
            </div>
            <div className="py-2">
                <div className="">
                    <Button
                        size="small"
                        variant="neutral"
                        text="Remove all filters"
                        iconBefore={<Check size={16} />}
                        onClick={resetAllFilters}
                    />
                </div>
            </div>
        </div>
    );
};
